module.exports = __webpack_public_path__ + "img/play-square.82297955.svg";